import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import FeaturesService from 'ember-feature-flags/services/features';
import PushService from 'cio/services/push';
import AnalyticsService from 'cio/services/analytics';

export default class PushRoute extends Route {
  @service features!: FeaturesService;
  @service push!: PushService;
  @service analytics!: AnalyticsService;

  crumb() {
    return {
      name: 'Push',
      path: 'actions.push',
    };
  }

  async model() {
    await this.push.loadCredentials.perform();
    let { platforms } = this.push;
    let isConfigured = (key: string) => platforms.some((p: any) => p.key === key);

    return {
      pushSettings: {
        android: isConfigured('android'),
        ios: isConfigured('ios'),
      },
    };
  }

  afterModel(model: any) {
    let { android, ios } = model.pushSettings;
    this.analytics.track('push', 'message_settings_viewed', { android, ios });
  }
}
